import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ZahValidators} from '../../core/form/validators';
import {AlgemeneMeldingInput} from './algemene-melding-input';
import {AlgemeneMelding} from '../algemene-melding';
import parseMoment from 'moment';

@Component({
    templateUrl: './algemene-melding-input.component.html',
    styleUrls: ['./algemene-melding-input.component.scss'],
    standalone: false
})
export class AlgemeneMeldingInputComponent implements OnInit {
  algemeneMelding = inject<AlgemeneMelding>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<AlgemeneMeldingInputComponent>>(MatDialogRef);

  algemeneMeldingInputForm: FormGroup;

  ngOnInit(): void {
    this.algemeneMeldingInputForm = new FormGroup({
      content: new FormControl(this.algemeneMelding?.getContent(), ZahValidators.notBlank),
      actiefVanDag: new FormControl(parseMoment(this.algemeneMelding?.getActiefVanDag(), 'YYYY-MM-DD'), Validators.required),
      actiefTotDag: new FormControl(parseMoment(this.algemeneMelding?.getActiefTotDag(), 'YYYY-MM-DD'), Validators.required),
    });
  }

  onSubmit(): void {
    this.dialogRef.close(
      new AlgemeneMeldingInput(
        this.content.value,
        this.actiefVanDag.value.format('YYYY-MM-DD'),
        this.actiefTotDag.value.format('YYYY-MM-DD'),
      ));
  }

  get content(): AbstractControl {
    return this.algemeneMeldingInputForm.controls.content;
  }

  get actiefVanDag(): AbstractControl {
    return this.algemeneMeldingInputForm.controls.actiefVanDag;
  }

  get actiefTotDag(): AbstractControl {
    return this.algemeneMeldingInputForm.controls.actiefTotDag;
  }
}
